import React from 'react';

interface ImageResultProps {
  url: string;
  alt?: string;
  caption?: string;
}

const ImageResult: React.FC<ImageResultProps> = ({ url, alt, caption }) => {
  return (
    <div className="relative group">
      <img
        src={url}
        alt={alt || 'Search result image'}
        className="w-full h-auto rounded-lg"
      />
      {caption && (
        <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-2 rounded-b-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <p className="text-sm">{caption}</p>
        </div>
      )}
    </div>
  );
};

export default ImageResult; 